module.exports = __webpack_public_path__ + "img/list.19353435.svg";